import React, { useMemo } from "react";
import { ConnectedProps } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GoalEvent, PlayerListElement, MatchLocationEnum } from "../../../client/api";
import PlayersInField from "./PlayersInField";
import { connector } from "./redux";
import Field from "./Field";
import { pathTeamView } from "../../../config/routes";

const Lineup: React.FC<ConnectedProps<typeof connector>> = ({
  team1Id,
  team2Id,
  lineup1,
  lineup2,
  team1,
  team2,
  cardEvents,
  changeEvents,
  goalEvents,
  matchId,
  fetchLineup,
  playerRatings,
}) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!lineup1 && matchId) fetchLineup(matchId, MatchLocationEnum.HOME);
    if (!lineup2 && matchId) fetchLineup(matchId, MatchLocationEnum.AWAY);
  }, [lineup1, lineup2, matchId, fetchLineup]);
  const changeEvents1 = useMemo(
    () => changeEvents.filter((event) => event.teamId === team1Id),
    [changeEvents, team1Id]
  );
  const changeEvents2 = useMemo(
    () => changeEvents.filter((event) => event.teamId === team2Id),
    [changeEvents, team2Id]
  );
  const goalEvents1 = useMemo(
    () =>
      goalEvents.filter(
        (event) => event.teamId === team1Id && !!event.player
      ) as (Omit<GoalEvent, "player"> & { player: PlayerListElement })[],
    [goalEvents, team1Id]
  );
  const goalEvents2 = useMemo(
    () =>
      goalEvents.filter(
        (event) => event.teamId === team2Id && !!event.player
      ) as (Omit<GoalEvent, "player"> & { player: PlayerListElement })[],
    [goalEvents, team2Id]
  );
  const cardEvents1 = useMemo(
    () => cardEvents.filter((event) => event.teamId === team1Id),
    [cardEvents, team1Id]
  );
  const cardEvents2 = useMemo(
    () => cardEvents.filter((event) => event.teamId === team2Id),
    [cardEvents, team2Id]
  );
  return (
    <div className="m-4 relative">
        <Field 
          team1={team1.emblem} 
          team2={team2.emblem}
          onClickTeam1={() => {
            navigate(pathTeamView(team1.id, "table"));
          }}
          onClickTeam2={() => {
            navigate(pathTeamView(team2.id, "table"));
          }}
        />

        {lineup1 && (
          <PlayersInField
            lineup={lineup1}
            cardEvents={cardEvents1}
            goalEvents={goalEvents1}
            changeEvents={changeEvents1}
            rotated={matchId === -1}
            team={team1}
            playerRatings={playerRatings}
          />
        )}
        {lineup2 && (
          <PlayersInField
            lineup={lineup2}
            cardEvents={cardEvents2}
            goalEvents={goalEvents2}
            changeEvents={changeEvents2}
            team={team2}
            rotated
            playerRatings={playerRatings}
          />
        )}
      </div>
  );
};

export default connector(Lineup);
